const STAGE=window.STAGE;

export default class TypoResize{
    static refresh(){
        return;
        let $element=$(".js-typo-resize-max");

        if(STAGE.width<576){
            $(".js-typo-resize").each(function(){
                $(this).css("font-size",""); //reset
                $element.removeClass("page-not-ready")
            });
        }else{
            if($element.length){
                let max=$element[0].height;
                if(max<100 || $element[0].naturalHeight<100 ){
                    setTimeout(function(){
                        TypoResize.refresh();
                    },500);
                    return;
                }
                //réduit la typo jusqu'à ce quelle fasse au max la taille de l'image
                $(".js-typo-resize").each(function(){
                    $(this).css("font-size",""); //reset
                    let i=0;
                    let sz=parseFloat($(this).css("font-size"));
                    while ($(this).width() > max -40 && i++<100){
                        $(this).css("font-size",sz--);
                    }
                    $element.removeClass("page-not-ready")
                });
            }
        }

    }
}



// WEBPACK FOOTER //
// ./fk.app/_src/typo/TypoResize.js